import { ContentType } from 'pleinchamp-api-client/dist/src/content/content';
import { Content } from 'pleinchamp-api-client/dist/src/content/search';
import { searchContent } from '@search/business/search.utils';

const NB_ACTU_LAST_ARTICLES = 3;
const EMPTY: Content[] = [];

function fetchLastActus(slug?: string) {
  if (!slug) {
    return Promise.resolve(EMPTY);
  }
  return searchContent({
    contentTypes: [ContentType.Article],
    exclude: slug,
    limit: NB_ACTU_LAST_ARTICLES,
    offset: 0,
  }).then(r => r.contents);
}

export { fetchLastActus };
